<template>
  <div
    class="space"
    :class="`space--${size}`">
  </div>
</template>

<script>
export default {
  name: 'Space',
  props: {
    size: {
      type: String,
      default: 'small'
    }
  }
}
</script>

<style lang="scss" scoped>
.space {
  &--small {
    height: calc(#{$page-padding} * 2)
  }

  &--medium {
    height: calc(#{$page-padding} * 5);
  }

  &--large {
    height: calc(#{$page-padding} * 10);
  }
}
</style>
